<script setup>
  import ModalTextInput from '@/components/controls/ModalTextInput.vue';

  const name = defineModel('name');
</script>

<template>
  <div class="jwx-modal__section">
    <div class="jwx-modal__section-body">
      <ModalTextInput
        v-model="name"
        id="device-android-name"
        name="device-android-name"
        labelText="Name"
        subText="Max 64 characters"
      />
    </div>
  </div>
</template>
